import styled from '@emotion/styled';
import { Button, Input } from 'antd';
import { appStyles } from '../../../../styles';

export const StyledUsersContainer = styled.div`
  .ant-table {
    margin-top: 1rem;
  }
  .ant-table-thead {
    border-bottom: 2px solid #eee;
  }
  .ant-table-tbody > tr > td {
    padding: 0.25rem !important;
  }
  .ant-table-thead > tr > th {
    background: #fff;
    text-transform: uppercase;
    font-size: 0.75rem;
    font-weight: 600;
    &:before {
      display: none;
    }
  }
  .ant-spin-nested-loading > div > .ant-spin {
    background: rgba(255, 255, 255, 0.7);
    max-height: 100%;
  }
  .ant-pagination-item a {
    line-height: 24px;
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background-color: transparent;
  }
  .ant-table-row {
    cursor: pointer;
    &:hover {
      background-color: #00be4b4d;
    }
    &.selected {
      background-color: #00be4b4d;
    }
  }
  .users-actions {
    margin-top: 0.25rem;
    text-align: right;
    button {
      height: 46px;
      background-color: black;
      border-color: black;
      font-weight: 500;
    }
    button[disabled] {
      background-color: #555;
      border-color: #555;
      color: white;
    }
  }
`;

export const StyledChooseWinnerRandomlyButton = styled(Button)`
  margin-top: 1.375rem;
  font-weight: 600;
  font-size: 0.875rem;
  height: 46px;
  border-color: #222;
  img {
    width: 18px;
    height: 18px;
    margin-right: 0.5rem;
  }
`;

export const StyledSearchInput = styled(Input)`
  ${appStyles.searchInput}
  height: 46px;
  .ant-input-suffix {
    width: 36px;
    height: 36px;
  }
`;
